import {logger} from 'yougile-util'
import {
  ChatCheckSyncReq,
  DataObjectId,
  EntitledHubLike,
  Hub,
  User
} from 'yougile-model'
import {globals} from '@extensions/globals-base'
import {UserAccess} from '@extensions/user-access'
import {Accounts} from './accounts'
import {Connector} from './connector'
import {Sync} from './sync'

export class DirectMessages {
  public static onConnected(): void {
    Connector.onRequest('chat', req => {
      if (globals.currentUserId !== req.invitedId) {
        throw new Error('Unexpected chat request')
      }
      const inviterId = req.inviterId
      const profile = Sync.getProfile()
      if (!profile.get(inviterId)) {
        UserAccess.createUserInCompany(inviterId, req.inviterEmail, profile)
        Accounts.addUsers([inviterId])
      }
      DirectMessages.getChatWith(inviterId, (h: Hub) => {
        Connector.request('chat-approve', {
          inviterId,
          inviterEmail: req.inviterEmail,
          inviterChatHubId: req.inviterChatHubId,
          invitedId: globals.currentUserId,
          invitedChatHubId: h.id
        }).catch(res => logger.warn(res.error))
      })
    })
  }

  public static getDirectChatUser(hub?: EntitledHubLike): User {
    if (!hub || hub.companyId !== Sync.profileId || !hub.title.includes('|')) {
      return undefined
    }
    const userId = hub.title
      .split('|')
      .filter(s => s !== globals.currentUserId)[0] as DataObjectId
    return Sync.getProfile().get(userId) as User
  }

  public static requestChatWith(userId: DataObjectId): Hub {
    return DirectMessages.getChatWith(userId, (h: Hub) => {
      if (!h.sync) {
        Connector.request('chat', {
          inviterId: globals.currentUserId,
          inviterEmail: (Sync.getProfile().get(globals.currentUserId) as User)
            .email,
          inviterChatHubId: h.id,
          invitedId: userId
        }).catch(res => logger.warn(res.error))
        h.sync = true
        h.commit()
      }
    })
  }

  public static checkChat(withUserId: DataObjectId): void {
    const userId = globals.currentUserId
    const profileId = Sync.profileId
    const hub = DirectMessages.getChatIfExists(withUserId)
    if (!hub || !userId) {
      return
    }
    const req: ChatCheckSyncReq = {
      chatHubId: hub.id,
      profileId,
      userId1: userId,
      userId2: withUserId
    }
    Connector.request('chat-check-sync', req)
      .then(res => {
        if (typeof res.sync === 'boolean' && !res.sync && hub.sync) {
          logger.log('sync = false', withUserId)
          hub.sync = false
          hub.commit()
        }
      })
      .catch(e => logger.warn(e))
  }

  public static getChatIfExists(userId: DataObjectId): Hub | undefined {
    const cnt = DirectMessages.getDirectChatsContainer()
    if (!cnt) {
      return undefined
    }
    const profile = Sync.getProfile()
    const chatName = [globals.currentUserId, userId].sort().join('|')
    return profile.findHubByTitle(chatName, cnt.id, true)
  }

  public static getDirectChatsContainer(): Hub | undefined {
    const profile = Sync.getProfile()
    return profile.findHubByTitle('Direct', profile.companyId, true)
  }

  public static getChatWith(
    userId: DataObjectId,
    onCreate?: (hub: Hub) => void
  ): Hub {
    const profile = Sync.getProfile()
    let cnt = DirectMessages.getDirectChatsContainer()
    if (!cnt) {
      logger.log('Creating hub for direct messages')
      cnt = new Hub(profile.companyId, 'Direct')
      profile.add(cnt, profile.companyId)
    }
    const chatName = [globals.currentUserId, userId].sort().join('|')
    let chat = profile.findHubByTitle(chatName, cnt.id, true)
    if (!chat) {
      logger.log('Creating new chat hub, direct messages with ' + userId)
      chat = new Hub(profile.companyId, chatName)
      profile.add(chat, cnt.id)
      if (onCreate) {
        Sync.onServerApprovedCreation(chat.companyId, chat.id, () =>
          onCreate(chat)
        )
      }
    } else {
      if (onCreate) {
        onCreate(chat)
      }
    }
    return chat
  }
}
